/** Fills {{name}} or {name} if a translation string was shown raw. */
export function applyPlaceholders(
  text: string,
  vars: Record<string, string>
) {
  return text.replace(
    /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}|\{([a-zA-Z0-9_]+)\}/g,
    (full, doubled: string | undefined, single: string | undefined) => {
      const key = doubled || single || ''
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : full
    }
  )
}
